import React from 'react';
import {useSelector} from 'react-redux';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Alert, TouchableOpacity, View} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
///////////////////////////
///////////// components
import {ContinueButton, BodyText} from 'src/Modules/CommonView';
import {
  getNavigateNextParams,
  getNavigatePrevParams,
} from 'src/Utils/huntFunctions_v2';
import {navigationRef} from 'src/Nav/navigationHelpers';

const HelpModal = () => {
  const {width} = useWindowDimensionsSafe();

  const classicHunt = useSelector((state) => state.groupInfo?.classic_hunt);

  const handleNextPress = () => {
    Alert.alert(
      'Are You Sure?',
      'This will advance all players to the next location or challenge.',
      [
        {
          text: 'Cancel',
          onPress: () => null,
        },
        {
          text: 'Yes',
          onPress: () => {
            const {route, params} = getNavigateNextParams();
            navigationRef.goBack(null);
            navigationRef.navigate(route, params);
          },
        },
      ],
    );
  };

  const handlePrevPress = () => {
    const {route, params} = getNavigatePrevParams();

    navigationRef.goBack(null);
    navigationRef.navigate(route, params);
  };

  console.log('HelpModal Render');

  return (
    <SafeAreaView style={{flex: 1}}>
      <TouchableOpacity
        onPress={() => navigationRef.goBack()}
        style={{flex: 1}}
      />
      <View style={{backgroundColor: global?.color?.white, minHeight: 300}}>
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10,
          }}>
          <BodyText text={'How Can We Help You?'} />
          <View style={{alignItems: 'center', marginVertical: 10}}>
            <ContinueButton
              text={`Contact Support`}
              containerStyle={{width: 220, marginTop: 10}}
              background={global?.color?.gray2}
              handlePress={() => {
                navigationRef.navigate('SupportModal');
              }}
            />
          </View>
        </View>
        {!classicHunt && (
          <View
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 10,
            }}>
            <BodyText text={'Force Navigation:'} />
            <View
              style={{
                flexDirection: 'row',
                width: width - 10,
                marginHorizontal: 5,
                marginVertical: 10,
                justifyContent: 'space-around',
              }}>
              <ContinueButton
                text={`Go Back A Page`}
                containerStyle={{flex: 1}}
                handlePress={() => {
                  handlePrevPress();
                }}
                background={global?.color?.blue}
              />
              <ContinueButton
                text={`Skip Ahead`}
                containerStyle={{flex: 1}}
                handlePress={() => {
                  handleNextPress();
                }}
                background={global?.color?.orange}
              />
            </View>
          </View>
        )}
        <View style={{alignItems: 'center', marginVertical: 10}}>
          <ContinueButton
            text={`Close`}
            containerStyle={{width: 220, marginTop: 10}}
            handlePress={() => {
              navigationRef.goBack();
            }}
            background={global?.color?.gray3}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};

export default HelpModal;
